module.exports = __webpack_public_path__ + "img/Kochen & Genuss.d0f485da.jpg";